import { render, staticRenderFns } from "./BranchCreateView.vue?vue&type=template&id=d587255a"
import script from "./BranchCreateView.vue?vue&type=script&lang=js"
export * from "./BranchCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports